"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.string.includes");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = consolidateParams;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _invariant = _interopRequireDefault(require("invariant"));

var toTransferCfgDefault = ['sku', 'ean', 'pn', ['manufacturer', function (o) {
  return o.name;
}]];
/**
 * Returns merged and normalized `Array` of product root parameters as 'sku', 'ean' ect. and
 * `products.parameters`.
 *
 * @param {Array} parametersSearchable
 * @param {function} translate translate function from useTranslate
 * @param {Object} options
 * @param {string} [options.parametersField = 'parameters']
 * @param {string} options.translationPrefix
 * @param {Array} options.toTransferCfg
 * @param {Object} product
 *
 * @returns Memoized merged and normalized `Array` of product parameters.
 */

function consolidateParams(parametersSearchable, translate, options, product) {
  var t = translate;

  var _ref = options || {},
      _ref$parametersField = _ref.parametersField,
      parametersField = _ref$parametersField === void 0 ? 'parameters' : _ref$parametersField,
      _ref$toTransferCfg = _ref.toTransferCfg,
      toTransferCfg = _ref$toTransferCfg === void 0 ? toTransferCfgDefault : _ref$toTransferCfg,
      translationPrefix = _ref.translationPrefix;

  (0, _invariant.default)(translationPrefix, 'consolidateParams requires translationPrefix');

  var _toTransferCfg$reduce = toTransferCfg.reduce(function (_ref2, i) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        ttr = _ref3[0],
        vm = _ref3[1];

    var _ref4 = Array.isArray(i) ? i : [i, function (v) {
      return v;
    }],
        _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
        x = _ref5[0],
        y = _ref5[1];

    return [[].concat((0, _toConsumableArray2.default)(ttr), [x]), (0, _extends3.default)({}, vm, (0, _defineProperty2.default)({}, x, y))];
  }, [[], {}]),
      _toTransferCfg$reduce2 = (0, _slicedToArray2.default)(_toTransferCfg$reduce, 2),
      toTransfer = _toTransferCfg$reduce2[0],
      valueMapper = _toTransferCfg$reduce2[1];

  var parameters = (product[parametersField] || []).map(function (param) {
    var parameter = parametersSearchable.find(function (i) {
      return i.code === param.code;
    }) || {};
    var enumValue = parameter.enum && Array.isArray(parameter.enum) ? (parameter.enum.find(function (p) {
      return p.code === param.value;
    }) || {}).label : undefined;
    return (0, _extends3.default)({}, param, {
      label: parameter.label || param.code,
      value: enumValue ? t(enumValue, {
        acceptString: true
      }) : param.value
    });
  });
  var rootParams = Object.entries(product).reduce(function (ret, _ref6) {
    var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
        field = _ref7[0],
        fieldValue = _ref7[1];

    return toTransfer.includes(field) ? [].concat((0, _toConsumableArray2.default)(ret), [{
      code: "/".concat(field),
      group: '/',
      label: t("".concat(translationPrefix, "/").concat(field, "/label")),
      helperText: t("".concat(translationPrefix, "/").concat(field, "/helperTextPreview")),
      value: valueMapper[field](fieldValue)
    }]) : ret;
  }, []);
  return [].concat((0, _toConsumableArray2.default)(rootParams), (0, _toConsumableArray2.default)(parameters));
}